<mat-form-field
  [appearance]="data.variant"
  class="common-textfield"
  [class.date-field]="data.type === 'date'"
  [class.red-border]="ngControl?.invalid && ngControl?.touched && data.required"
>
  @if (data.label) {
  <mat-label>
    <span class="label-with-help" [class.date-label]="data.type === 'date'">
      @if (data.type === 'date') {
      <span
        class="truncate-text"
        [matTooltip]="data.label"
        matTooltipPosition="above"
        >{{ data.label }}</span
      >
      } @else {
      <span>{{ data.label }}</span>
      } @if (data.required && data.label) {
      <span class="required-star">*</span>
      } @if (data.isHelpText && data.instructions) {
      <mat-icon
        class="help-info-icon"
        [matTooltip]="data.instructions"
        matTooltipPosition="above"
        matTooltipClass="custom-tooltip-style"
      >
        error_outline
      </mat-icon>
      }
    </span>
  </mat-label>
  } @if (data.prefix !== '') {
  <ng-container matPrefix>
    <div class="prefix-text">
      <wm-common-text [data]="{ text: data.prefix }"></wm-common-text>
    </div>
  </ng-container>
  }
  <!-- Added by Vipul on 22-02-2026 -->
  @if (data.suffix && data.suffix !== '') {
  <ng-container matSuffix>
    <div class="suffix-text">
      <wm-common-text [data]="{ text: data.suffix }"></wm-common-text>
    </div>
  </ng-container>
  }
  <!-- End by Vipul on 22-02-2026 -->

  @if (data.startIcon.matIconName !== '' && data.type !== 'date') {
  <ng-container matPrefix>
    <button mat-icon-button (click)="handleStartIconClick($event)">
      <mat-icon>{{ data.startIcon.matIconName }}</mat-icon>
    </button>
  </ng-container>
  } @if (data.type === 'text-area') {
  <textarea
    matInput
    [rows]="data.textAreaRows"
    [id]="data.id"
    [placeholder]="data.placeholder"
    [disabled]="disabled"
    [readonly]="data.readonly"
    [value]="_value"
    (input)="onValueChange($event)"
    (blur)="onBlur()"
  ></textarea>

  } @else if (data.type === 'number') {
  <!-- added by furkan 22-05-2026 inputmode= deciaml so that it should accepts decimal point   -->
  <input
    matInput
    [placeholder]="data.placeholder"
    [id]="data.id"
    [type]="data.type"
    inputmode="decimal"
    [disabled]="disabled"
    [readonly]="data.readonly"
    [value]="_value"
    (input)="onValueChange($event)"
    (blur)="onBlur()"
    [wmNumberFormat]="data.decimalPlaces"
    [attr.min]="data.min"
    [attr.max]="data.max"
    [step]="data.step"
  />

  } @else if (data.type === 'date') {
  <!-- <div style="display:flex;flex-direction: row">
      <input matInput [placeholder]="data.placeholder" [matDatepicker]="picker" [matDatepickerFilter]="dateFilter" [min]="minDate" [max]="maxDate"
        [value]="_value" [disabled]="disabled" (dateChange)="onDateChange($event)" (dateInput)="onDateChange($event)" (blur)="onBlur()" (keydown)="onDateKeyDown($event)" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker (closed)="onBlur()"></mat-datepicker>
    </div> -->

  <div style="display:flex; flex-direction: row; align-items: center; justify-content: end;">
    <input
      matInput
      [placeholder]="data.placeholder || 'MM/DD/YYYY'"
      [matDatepicker]="picker"
      [matDatepickerFilter]="dateFilter"
      [min]="minDate"
      [max]="maxDate"
      [disabled]="disabled"
      [readonly]="data.readonly"
      maxlength="10"
      [value]="_dateValue"
      (keydown)="onDateKeyDown($event)"
      (input)="onDateInput($event)"
      (paste)="onDatePaste($event)"
      (dateChange)="onDateChange($event)"
      (blur)="onBlur()"
    />

    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker (closed)="onBlur()"></mat-datepicker>
  </div>

  } @else {
  <input
    matInput
    [placeholder]="data.placeholder"
    [id]="data.id"
    [type]="data.type"
    [disabled]="disabled"
    [readonly]="data.readonly"
    [value]="_value"
    (input)="onValueChange($event)"
    (blur)="onBlur()"
  />
  } @if (data.endIcon?.matIconName !== '') {
  <ng-container matSuffix>
    <button mat-icon-button (click)="handleEndIconClick($event)">
      <mat-icon>{{ data.endIcon.matIconName }}</mat-icon>
    </button>
  </ng-container>
  }

  <!-- @if (isTemplate(data.helperText) && ngControl?.invalid && ngControl?.touched) {
    <mat-hint><ng-template [ngTemplateOutlet]="data.helperText"></ng-template></mat-hint>
  } @else if (data.helperText && ngControl?.invalid && ngControl?.touched) {
    <mat-hint class="error-text">{{ data.helperText }}</mat-hint>
  }

  @if (ngControl?.errors?.['invalidDate']) {
    <mat-hint class="error-text">
      Please enter a valid date
    </mat-hint>
  } -->

  @if (ngControl?.errors?.['invalidDate']) {
  <mat-hint class="error-text">
    Please enter a valid date
  </mat-hint>
  } @else if (isTemplate(data.helperText) && ngControl?.invalid &&
  ngControl?.touched) {
  <mat-hint>
    <ng-template [ngTemplateOutlet]="data.helperText"></ng-template>
  </mat-hint>
  } @else if (data.helperText && ngControl?.invalid && ngControl?.touched) {
  <mat-hint class="error-text">
    {{ data.helperText }}
  </mat-hint>
  }
</mat-form-field>
